import { Target, Rocket, Award, CheckCircle } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-32" style={{ background: 'var(--bg-dark)' }}>
      {/* Background Accent */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#3B82F6]/5 rounded-full blur-[150px]"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#8B5CF6]/5 rounded-full blur-[150px]"></div>

      <div className="relative max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3B82F6]/10 border border-[#3B82F6]/30 rounded-full mb-6">
              <span className="text-[#3B82F6] text-sm font-semibold">About CLOUD IT</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" style={{ letterSpacing: '-0.02em' }}>
              Forward-Thinking{' '}
              <span className="bg-gradient-to-r from-[#3B82F6] to-[#8B5CF6] bg-clip-text text-transparent">
                Digital Innovation
              </span>{' '}
              Company
            </h2>
            
            <p className="text-lg text-white/70 mb-6 leading-relaxed">
              CLOUD IT is a forward-thinking digital innovation company focused on delivering scalable, secure, and intelligent solutions for modern businesses.
            </p>
            
            <p className="text-base text-white/50 mb-8 leading-relaxed">
              We combine cutting-edge technology with strategic thinking to create digital experiences that drive real business results. Our team of experts specializes in crafting bespoke solutions that adapt and evolve with your business needs.
            </p>

            {/* Key Points */}
            <div className="space-y-5">
              <div className="flex items-start gap-4 group">
                <div className="bg-[#3B82F6]/10 p-3 rounded-xl border border-[#3B82F6]/30 transition-all duration-400 group-hover:bg-[#3B82F6]/20 group-hover:scale-110">
                  <Target size={22} className="text-[#3B82F6]" />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-lg mb-1">Strategic Vision</h3>
                  <p className="text-white/50 text-sm">Transforming business challenges into innovative digital solutions</p>
                </div>
              </div>

              <div className="flex items-start gap-4 group">
                <div className="bg-[#8B5CF6]/10 p-3 rounded-xl border border-[#8B5CF6]/30 transition-all duration-400 group-hover:bg-[#8B5CF6]/20 group-hover:scale-110">
                  <Rocket size={22} className="text-[#8B5CF6]" />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-lg mb-1">Innovation First</h3>
                  <p className="text-white/50 text-sm">Leveraging the latest technologies to keep you ahead</p>
                </div>
              </div>

              <div className="flex items-start gap-4 group">
                <div className="bg-[#F97316]/10 p-3 rounded-xl border border-[#F97316]/30 transition-all duration-400 group-hover:bg-[#F97316]/20 group-hover:scale-110">
                  <Award size={22} className="text-[#F97316]" />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-lg mb-1">Excellence Driven</h3>
                  <p className="text-white/50 text-sm">Committed to delivering exceptional quality and results</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl border border-white/10">
              <img 
                src="https://images.unsplash.com/photo-1523961131990-5ea7c61b2107?w=800" 
                alt="Technology"
                className="w-full h-[500px] object-cover transition-transform duration-700 hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0F] via-transparent to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-[#12121A]/95 backdrop-blur-xl border border-white/10 p-6 rounded-2xl shadow-2xl">
              <div className="text-4xl font-bold bg-gradient-to-r from-[#3B82F6] to-[#8B5CF6] bg-clip-text text-transparent mb-2">10+</div>
              <div className="text-white/80 font-medium">Years of Excellence</div>
            </div>

            {/* Additional Badge */}
            <div className="absolute -top-4 -right-4 bg-gradient-to-r from-[#F97316] to-[#FB923C] p-4 rounded-xl shadow-xl">
              <CheckCircle size={28} className="text-white" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
